module.exports = __webpack_public_path__ + "d39ed83e0efca0d1fd8bfdb584008e9c.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/sound/guitar/6_F2.mp3
// module id = 81
// module chunks = 0